import React, { act, useEffect } from "react";
import Thread from "../thread/thread";
import { EventEmitter } from "../../../../shared/utils/event-emitter";
import Events from "../../../../const/events";
import ThreadHelper from "../../../../entities/thread/thread-helper";
import { useSelector } from "react-redux";
import { DebounceInput } from "react-debounce-input";
import useDeepCompareEffect from "use-deep-compare-effect";
import TemplateHelper from "../../../../entities/templates/template-helper";
import useInfiniteScroll from "../../../../shared/utils/use-infinite-scroll";
import "./threads-list-viewer.scss";
import router from "../../../../shared/top-level-declarations/history";

const ThreadsListViewer = ({ threadType = "individual" }) => {
  const [unreadCounts, setUnreadCounts] = React.useState({
    room: 0,
    individual: 0,
  });
  const allThreads = useSelector(
    (state) => state?.threadStore?.allThreads || []
  );
  const isLoaderActive = useSelector(
    (state) => state?.threadStore?.isLoaderActive || false
  );
  const selectedThread = useSelector(
    (state) => state?.threadStore?.selectedThread || null
  );
  const searchText = useSelector(
    (state) => state?.threadStore?.searchText || ""
  );
  const pagination = useSelector(
    (state) => state?.threadStore?.pagination || {}
  );

  // Infinite scroll setup
  const { containerRef, isLoadingMore } = useInfiniteScroll(
    ThreadHelper.loadNextPage,
    pagination.hasNextPage,
    isLoaderActive
  );

  const _updateSearchText = (e) => {
    ThreadHelper.setSearchText(e.target.value);
  };
  const _showCreateThreadPopup = () => {
    EventEmitter.dispatch(Events.SHOW_CREATE_THREAD_POPUP);
  };
  const _showRoomUploadPopup = () => {
    router.navigate("/connect-contacts");
    // EventEmitter.dispatch(Events.SHOW_CSV_ROOM_IMPORT_POPUP);
  };
  useEffect(() => {
    const _loadThreads = () => {
      ThreadHelper.loadThreadsList({ threadType });
    };
    const _loadTwilioTemplates = () => {
      TemplateHelper.loadTwilioTemplates();
    };
    _loadTwilioTemplates();
    _loadThreads();
  }, [threadType]);


  useDeepCompareEffect(() => {
    const unreadCounts = {
      room: 0,
      individual: 0,
    };

    allThreads.forEach((thread) => {
      if (thread.type === "room") {
        unreadCounts.room += thread.unreadMessages || 0;
      } else {
        unreadCounts.individual += thread.unreadMessages || 0;
      }
    });

    setUnreadCounts(unreadCounts);
  }, [allThreads]);

  return (
    <>
      <div className="chat-search mt-0 mb-3">
        {threadType === "individual" ? (
          <div className="chat-new-start mb-3">
            <button
              type="button"
              className="bouncy-button small w-100"
              onClick={_showCreateThreadPopup}
            >
              <i className="mdi mdi-plus"></i>
              <span>Message Contact</span>
            </button>
          </div>
        ) : (
          <div className="chat-new-start mb-3">
            <button
              type="button"
              className="bouncy-button small w-100"
              onClick={_showRoomUploadPopup}
            >
              <i className="mdi mdi-plus h-auto"></i>
              <span>Connect Contacts</span>
            </button>
          </div>
        )}

        <div className="form-group">
          <div className="input-group">
            <DebounceInput
              minLength={2}
              debounceTimeout={300}
              onChange={_updateSearchText}
              id="chat-search"
              name="chat-search"
              className="form-control"
              placeholder="Search"
              value={searchText}
            />
          </div>
        </div>
      </div>
      {/*end chat-search*/}

      <div className="chat-body-left" id="all_chat" ref={containerRef}>
        <div className="chat-list">
          {isLoaderActive && (
            <div className="thread-loader-wrapper">
              <img
                src="assets/images/ring-loader.svg"
                alt="loader"
                className="loader"
              />
            </div>
          )}
          {allThreads.length === 0 && !isLoaderActive && (
            <div className="no-threads">
              <h4>No threads found</h4>
              <p>Start a new conversation by clicking the button above</p>
            </div>
          )}

          {/* Loop through allThreads and render a Thread component for each */}
          {allThreads.map((thread) => {
            let contactName = "Unknown Contact";

            if (thread.title && thread._contacts?.length > 1) {
              contactName = thread.title;
            } else if (thread._contacts?.length) {
              contactName = thread._contacts[0].name
                ? thread._contacts[0].name
                : thread._contacts[0].name;
            }
            const lastMessage =
              thread.lastMessagePreview || "No messages yet";
            const unreadCount = thread.unreadMessages || 0;

            // No need for frontend filtering anymore - API handles it
            // The threads are already filtered by type from the backend

            if (thread.type === "room" && thread?._contacts?.length === 2) {
              contactName = `${thread._contacts[0].name} & ${
                thread._contacts[1].name
              }`;
            }

            return (
              <Thread
                key={thread._id}
                threadId={thread._id}
                userImg={
                  thread.type === "room" ? "/assets/images/group_duo.png" : ""
                } // Assuming no user image for now
                userInitials={contactName.charAt(0)}
                userName={contactName}
                message={lastMessage}
                date={thread.updatedAt}
                unreadCount={unreadCount}
                isActive={selectedThread?._id === thread._id}
                thread={thread}
              />
            );
          })}
          
          {/* Infinite scroll loading indicator */}
          {isLoadingMore && (
            <div className="thread-loader-wrapper">
              <img
                src="assets/images/ring-loader.svg"
                alt="loading more"
                className="loader"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ThreadsListViewer;
